import React from "react";

export default function CancelPolicy() {
  return (
    <main>
      <div
        style={{
          maxWidth: "1240px",
          margin: "4rem auto",
          padding: "0 1rem",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <h5>Cancellation Policy</h5>
        <p>
          Currently, we do not have any cancellation policy. we will update here
          once we start.
        </p>
      </div>
    </main>
  );
}
